<div [ngStyle]="{ position: position, width: position === 'absolute' ? '100%' : null, top: position === 'absolute' ? '10%' : null }" class="loading-container">
    <div class="loading-content">
        <div class="loading-spinner"></div>
        <p>Wird geladen...</p>
    </div>
</div>